import React, { useRef, useState } from "react";
import { AnimatedTick, Button, CustomFields, Employee, Modal, Toast } from "../../../../../../../../Components";
import { ApprovalNotes, approvalIntro } from "../../../../../../../../Components/OutOfPolicyBadge/status";
import { useNavigate } from "react-router-dom";
import FlightCard from "./flightCard";
import { FaShieldAlt } from "react-icons/fa";
import { apis, post } from "../../../../../../../../Utils/axios";
import moment from "moment";
function AskApproval({ flight, fare, type, violations }) {
	const NAVIGATE = useNavigate();
	const [ShowPrompt, setShowPrompt] = useState();
	const [Approvers, setApprovers] = useState([]);
	const [Loading, setLoading] = useState();
	const NOTES = useRef();
	const GET_CUSTOM_FIELDS = useRef();

	const sendApproval = () => {
		const customFields = GET_CUSTOM_FIELDS?.current?.();
		if (!customFields) {
			//Required custom fields not filled
			return false;
		}
		setLoading(true);
		post(
			apis.askRoundFlightApproval,
			{
				flight: {
					...flight,
					duration: flight?.onwardDuration,
					segments: flight?.onwardSegments,
				},
				fare,
				type,
				notes: NOTES.current.value,
				date: moment().format("DD-MM-YYYY"),
			},
			(r, e) => {
				setLoading(false);
				if (r) {
					setApprovers(r.approvers);
					Toast.success("Approval request submitted successfully.");
				} else if (e) {
					Toast.handleError(e);
				}
			}
		);
	};

	return (
		<>
			<Button onClick={() => setShowPrompt(true)} variant="primary" className="w-full">
				Ask for Approval
			</Button>
			<Modal
				open={ShowPrompt}
				onClose={() => {
					setShowPrompt(false);
					setApprovers([]);
				}}
				contentClass="!max-w-[30rem] max-h-[calc(100vh-2rem)] !max-h-[calc(100dvh-2rem)] flex flex-col overflow-hidden"
			>
				{Approvers.length > 0 ? (
					<div className="p-8">
						<AnimatedTick />
						<h1 className="mt-4 flex-center">Request Sent</h1>
						<div className="text-sm text-center">We have sent a request to your manager. You can track the status of approval in Flight bookings</div>
						<div className="flex-col gap-2 mt-6 flex-center">
							<Employee className="bg-light" employee={Approvers[0]} />
						</div>
						<div className="mt-6">
							<Button
								onClick={() => {
									setShowPrompt(false);
									setApprovers([]);
									NAVIGATE("/app/bookings");
								}}
								className="w-full"
							>
								Go to Flight Bookings
							</Button>
						</div>
					</div>
				) : (
					<div className="flex flex-col min-h-0">
						<div className="flex-1 min-h-0 overflow-y-auto p-6">
							<h1 className="gap-2 align-center">
								<FaShieldAlt />
								Ask for Approval
							</h1>
							<div className="p-2 text-sm">{approvalIntro(fare, violations)}</div>
							<ApprovalNotes fare={fare} violations={violations} />
							<div className="mt-4 border rounded-md">
								<FlightCard {...flight} />
							</div>
							<div className="flex flex-col gap-2 mt-4">
								<label>Notes (Optional)</label>
								<textarea ref={NOTES} className="input" placeholder="Notes to the approver" />
							</div>
							<CustomFields className="mt-4" getCustomFields={GET_CUSTOM_FIELDS} activity="FLIGHT_BOOK" />
						</div>
						<div className="shrink-0 p-4 pt-3 border-t border-surface bg-canvas">
							<Button onClick={sendApproval} loading={Loading} className="w-full" variant="primary">
								Yes, Ask for Approval
							</Button>
						</div>
					</div>
				)}
			</Modal>
		</>
	);
}

export default AskApproval;
